import { get } from '@ember/helper';
import { t } from 'ember-intl';
import BvBadge from 'volta/components/bv-badge';
import BvBtn from 'volta/components/bv-btn';
import BvIcon from 'volta/components/bv-icon';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';
import ForecastProjectTitle from 'volta/components/forecast-project/forecast-project-title';
import { ForecastProjectStatusColors } from 'volta/models/forecast-project';

import type { TOC } from '@ember/component/template-only';
import type { ForecastProjectTaskEntityPayload } from 'volta/models/forecast-project-task';

interface TasksKitListForecastProjectPayloadSignature {
  Args: {
    id: string;
    payload: ForecastProjectTaskEntityPayload;
  };
  Element: HTMLElement;
}

const TasksKitListForecastProjectPayloadComponent: TOC<TasksKitListForecastProjectPayloadSignature> =
  <template>
    <BvBtn
      @route='protected.forecast-project'
      @routeModel={{@id}}
      @subtle={{true}}
      @size='sm'
      ...attributes
    >
      <ForecastProjectTitle @forecastProject={{@payload}} class='u-mr-2' />
      {{#let (get ForecastProjectStatusColors @payload.status) as |statusOption|}}
        <BvBadge @color={{statusOption.color}} @size='sm' @outline={{false}} class='u-pr-2'>
          <BvInline @gap='1' @blockAlign='center' @wrap={{false}}>
            <BvIcon @glyph={{statusOption.icon}} @color={{statusOption.color}} @size='sm' />
            <BvText @text={{t statusOption.label}} />
          </BvInline>
        </BvBadge>
      {{/let}}
    </BvBtn>
  </template>;

export default TasksKitListForecastProjectPayloadComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List::ForecastProjectPayload': typeof TasksKitListForecastProjectPayloadComponent;
    'tasks-kit/list/forecast-project-payload': typeof TasksKitListForecastProjectPayloadComponent;
  }
}
